import React from "react";
import { motion } from "framer-motion";
import { LanguagesIcon, RadarIcon, HandshakeIcon } from "lucide-react";
const modules = [{
  icon: LanguagesIcon,
  title: "El Método de Percepción Nativa",
  desc: "Configura tus herramientas de IA para que cada palabra suene a un CEO nacido en Nueva York."
}, {
  icon: RadarIcon,
  title: "Prospecting Automatizado",
  desc: "Encuentra a los 'peces gordos' en USA y contáctalos masivamente sin que parezca spam."
}, {
  icon: HandshakeIcon,
  title: "Cerrando el Trato",
  desc: "El protocolo para manejar objeciones en inglés y que el cliente quiera pagarte en dólares, no en pesos."
}];
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a1f] py-16" data-id="element-235" data-mp="18zza1m6y62rr">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-236" data-mp="1wquz4bk0qjvb">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-4xl" data-id="element-237" data-mp="1wpbigjuga6t0">
          Esto es lo que vas a lograr{" "}
          <span className="text-violet-400" data-id="element-238" data-mp="2vftys1exqxhh">hoy</span>
        </h2>
        <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-239" data-mp="2vg3p5q3w76np">
          {modules.map((m, i) => <motion.div key={m.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.1
        }} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-colors hover:border-violet-500/40" data-id="element-240" data-mp="2qikawq772tvr" data-mpi={i}>
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-violet-500/15 text-violet-300" data-id="element-241" data-mp="396p9lj8zvonp">
                <m.icon className="h-6 w-6" data-id="element-242" data-mp="3o2eypq9h8hwn" />
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-white" data-id="element-243" data-mp="3j6g1rea31rkm">
                {m.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-300" data-id="element-244" data-mp="1tqqhtijoq59m">{m.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}